import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../../../user/selectors'
import { getPcrIdSelector } from '../../../../home/selectors'
import { PcrDocsService } from '../../../../../services/pcrDocs.service'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { getWasPatientImmbobilizedSelector } from '../selectors'
import { IWasPatientImmobilizedState } from '../store/wasPatientImmobilized.types'
import { WasPatientImmobilizedConstants } from '../store/wasPatientImmobilized.constants'
import { getSelectedDataFromObject } from '../../../../../utilities/data.util'
import { wasPatientImmobilizedPrAssess, wasPatientImmobilizedPrNabc } from '../store/wasPatientImmobilized.reducers'
import { getNeuroSelector } from '../../selectors'
import { INeuroState } from '../../store/neuro.types'
import { _featureRefKey } from '../../store/neuro.reducers'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

export function* saveWasPatientImmobilized() {
  const wasPatientImmobilized: IWasPatientImmobilizedState = yield select(getWasPatientImmbobilizedSelector)
  const neuroData: INeuroState = yield select(getNeuroSelector)
  const serviceId: string = yield select(getServiceIdSelector)

  const { _toggleWasPtImmFlag } = neuroData
  const pcrID: string = yield select(getPcrIdSelector)

  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

    const prNabcKeys: any = Object.keys(wasPatientImmobilizedPrNabc)
    const prNabcData = getSelectedDataFromObject(wasPatientImmobilized, prNabcKeys)

    const prAssessKeys: any = Object.keys(wasPatientImmobilizedPrAssess)
    const prAssessObj: any = getSelectedDataFromObject(wasPatientImmobilized, prAssessKeys)

    const prAssess = pcrDoc.prAssess ? [...pcrDoc.prAssess] : []
    const prAssessObjIndex = prAssess.findIndex((prAssObj) => prAssObj._featureRefKey === _featureRefKey)

    if (prAssessObjIndex !== -1) {
      prAssess[prAssessObjIndex] = { ...prAssess[prAssessObjIndex], ...prAssessObj }
    } else {
      prAssess.push({ ...prAssessObj, _featureRefKey })
    }

    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      prNabc: {
        ...pcrDoc.prNabc,
        ...prNabcData,
        _toggleWasPtImmFlag: _toggleWasPtImmFlag,
      },
      prAssess: prAssess,
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveWasPatientImmobilized() error: ${e}`))
    }
  }
}

export function* saveWasPatientImmobilizedSaga() {
  yield takeLatest(
    [WasPatientImmobilizedConstants.SAVE_WAS_PATIENT_IMMOBILIZED],
    performWithMutexHOG,
    saveWasPatientImmobilized
  )
}
